import { render, staticRenderFns } from "./user-settings.vue?vue&type=template&id=03947184"
import script from "./user-settings.vue?vue&type=script&lang=js"
export * from "./user-settings.vue?vue&type=script&lang=js"
import style0 from "./user-settings.vue?vue&type=style&index=0&id=03947184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports